/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { ContactService } from './services/contact.service';
import { ConversationService } from './services/conversation.service';
import { DocumentService } from './services/document.service';
import { DocumentSearchService } from './services/document-search.service';
import { FastAccessViewService } from './services/fast-access-view.service';
import { FavoriteService } from './services/favorite.service';
import { GlobalSearchService } from './services/global-search.service';
import { IconService } from './services/icon.service';
import { LastEditedService } from './services/last-edited.service';
import { LegacyService } from './services/legacy.service';
import { MagnetService } from './services/magnet.service';
import { NewDocumentService } from './services/new-document.service';
import { OrganisationService } from './services/organisation.service';
import { SearchQueryService } from './services/search-query.service';
import { ServerInformationService } from './services/server-information.service';
import { StampService } from './services/stamp.service';
import { TagService } from './services/tag.service';
import { TaskService } from './services/task.service';
import { UsageTelemetryService } from './services/usage-telemetry.service';
import { VaultService } from './services/vault.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    ContactService,
    ConversationService,
    DocumentService,
    DocumentSearchService,
    FastAccessViewService,
    FavoriteService,
    GlobalSearchService,
    IconService,
    LastEditedService,
    LegacyService,
    MagnetService,
    NewDocumentService,
    OrganisationService,
    SearchQueryService,
    ServerInformationService,
    StampService,
    TagService,
    TaskService,
    UsageTelemetryService,
    VaultService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
